/* SCNY — mobile audio coordinator.
   Old version replayed every tap as synthetic mouse events. Phones already fire a
   native click after touchend, so players got TWO clicks per tap: play -> pause.
   It also force-played every <audio> on any tap/tab return, so pause never stuck.
   This version: no replay, no forced play. One sound source at a time.
   Debug: add #scnydebug to URL on phone. */
(() => {
  const DEBUG = location.hash.includes('scnydebug');
  const HINT = /music|audio|player|bgm|sound|track/i;
  const TOP = '2147483000';
  const log = [];
  const note = (msg) => {
    if (!DEBUG) return;
    log.push(msg);
    if (log.length > 40) log.shift();
    renderDebug();
  };
  const label = (el) =>
    el ? (el.tagName + (el.id ? '#' + el.id : '') + '.' + String(el.className || '')).slice(0, 80) : 'null';

  /* 1. one source at a time: Music Player app, SCNY player, Untitled embed, hero unmute */
  const pauseAudioExcept = (keep) => {
    document.querySelectorAll('audio').forEach((a) => {
      if (a.paused) return;
      if (keep && (a === keep || (keep.contains && keep.contains(a)))) return;
      a.pause();
      note('paused: ' + label(a));
    });
  };

  document.addEventListener(
    'play',
    (e) => {
      const el = e.target;
      if (!(el instanceof HTMLMediaElement)) return;
      if (el.tagName === 'VIDEO' && el.muted) return;
      note('play: ' + label(el));
      pauseAudioExcept(el);
      if (el.tagName === 'AUDIO' && !el.closest('scny-audio-player')) {
        document.dispatchEvent(new CustomEvent('scny:audio-play', { detail: el }));
      }
    },
    true
  );

  document.addEventListener('scny:audio-play', (e) => pauseAudioExcept(e.detail));
  document.addEventListener('scny:video-unmute', () => pauseAudioExcept(null));

  document.addEventListener(
    'error',
    (e) => {
      const el = e.target;
      if (el instanceof HTMLMediaElement) note('media error ' + (el.error && el.error.code) + ': ' + (el.currentSrc || el.src));
    },
    true
  );

  /* 2. keep floating app widget above theme layers — widget only, never its children */
  const isFloatingWidget = (el) => {
    if (el.closest('#MainContent, header, footer, dialog, [class*="ai-music-player"]')) return false;
    const tag = (el.id || '') + ' ' + (typeof el.className === 'string' ? el.className : '');
    if (!HINT.test(tag)) return false;
    if (getComputedStyle(el).position !== 'fixed') return false;
    const r = el.getBoundingClientRect();
    return r.width >= 20 && r.height >= 20 && r.width <= 900;
  };

  const lift = () => {
    document.querySelectorAll('body > *, body > * > *').forEach((el) => {
      if (el.dataset.scnyLifted || !isFloatingWidget(el)) return;
      el.dataset.scnyLifted = '1';
      el.style.setProperty('z-index', TOP, 'important');
      el.style.setProperty('pointer-events', 'auto', 'important');
      el.style.setProperty('touch-action', 'manipulation', 'important');
      note('lifted: ' + label(el));
    });
  };

  let queued = false;
  const queueLift = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      lift();
    });
  };

  const start = () => {
    lift();
    new MutationObserver(queueLift).observe(document.body, { childList: true });
    setTimeout(lift, 1500);
    setTimeout(lift, 4000);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* 3. debug panel */
  let box = null;
  function renderDebug() {
    if (!DEBUG || !document.body) return;
    if (!box) {
      box = document.createElement('pre');
      box.style.cssText =
        'position:fixed;left:0;right:0;bottom:0;z-index:2147483647;background:#000;color:#0f0;' +
        'font:10px/1.3 monospace;padding:8px;max-height:40vh;overflow:auto;margin:0;' +
        'white-space:pre-wrap;pointer-events:none';
      document.body.appendChild(box);
    }
    const ctxs = window.__scnyAudioContexts ? [...window.__scnyAudioContexts].map((c) => c.state) : [];
    box.textContent =
      'audio els: ' + document.querySelectorAll('audio').length +
      ' | ctx: ' + (ctxs.join(',') || 'none') +
      ' | session: ' + ((navigator.audioSession && navigator.audioSession.type) || 'n/a') + '\n' +
      'iframes: ' + [...document.querySelectorAll('iframe')].map((f) => (f.src || '').slice(0, 50)).join(' ') + '\n' +
      log.join('\n');
  }
  if (DEBUG) {
    addEventListener('load', () => setTimeout(renderDebug, 1500));
    addEventListener('touchend', () => setTimeout(renderDebug, 400), { passive: true });
  }
})();
